<template>
  <div class="tw-w-full">
    <h3 class="tw-font-bold tw-text-xl tw-mb-2">Tax Savings Assumptions</h3>
    <div class="tw-flex tw-flex-col tw-gap-2">
      <div>
        <label for="incomeTaxRate" class="tw-block tw-mb-1 tw-text-sm">Income Tax Rate (%)</label>
        <input id="incomeTaxRate" v-model.number="localIncomeTaxRate" type="number" min="0" max="100" class="tw-border tw-rounded tw-p-1 tw-w-full">
      </div>
      <div>
        <label for="ltcgTaxRate" class="tw-block tw-mb-1 tw-text-sm">Long-Term Capital Gains Tax Rate (%)</label>
        <input id="ltcgTaxRate" v-model.number="localLtcgTaxRate" type="number" min="0" max="100" class="tw-border tw-rounded tw-p-1 tw-w-full">
      </div>
      <div>
        <label for="yearsToWithdrawal" class="tw-block tw-mb-1 tw-text-sm">Years to Withdrawal</label>
        <input id="yearsToWithdrawal" v-model.number="localYearsToWithdrawal" type="number" min="1" class="tw-border tw-rounded tw-p-1 tw-w-full">
      </div>
      <div>
        <label for="bondYield" class="tw-block tw-mb-1 tw-text-sm">Bond Yield (%)</label>
        <input id="bondYield" v-model.number="localAssumptions.bondYield" type="number" min="0" max="100" step="0.1" class="tw-border tw-rounded tw-p-1 tw-w-full">
      </div>
      <div>
        <label for="stockGrowthRate" class="tw-block tw-mb-1 tw-text-sm">Stock Annual Growth Rate (%)</label>
        <input id="stockGrowthRate" v-model.number="localAssumptions.stockGrowthRate" type="number" min="0" max="100" step="0.1" class="tw-border tw-rounded tw-p-1 tw-w-full">
      </div>
      <div>
        <label for="realEstateIncome" class="tw-block tw-mb-1 tw-text-sm">Real Estate Annual Income (%)</label>
        <input id="realEstateIncome" v-model.number="localAssumptions.realEstateIncome" type="number" min="0" max="100" step="0.1" class="tw-border tw-rounded tw-p-1 tw-w-full">
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    incomeTaxRate: Number,
    ltcgTaxRate: Number,
    yearsToWithdrawal: Number,
    assumptions: Object
  },
  emits: ['update:incomeTaxRate', 'update:ltcgTaxRate', 'update:yearsToWithdrawal', 'update:assumptions'],
  data() {
    return {
      localIncomeTaxRate: this.incomeTaxRate,
      localLtcgTaxRate: this.ltcgTaxRate,
      localYearsToWithdrawal: this.yearsToWithdrawal,
      localAssumptions: { ...this.assumptions }
    }
  },
  watch: {
    localIncomeTaxRate(newValue) {
      this.$emit('update:incomeTaxRate', newValue);
    },
    localLtcgTaxRate(newValue) {
      this.$emit('update:ltcgTaxRate', newValue);
    },
    localYearsToWithdrawal(newValue) {
      this.$emit('update:yearsToWithdrawal', newValue);
    },
    localAssumptions: {
      handler(newValue) {
        this.$emit('update:assumptions', newValue);
      },
      deep: true
    }
  }
}
</script>